import React from 'react';
import PeopleIcon from '@mui/icons-material/People';
import { H3, Body3 } from '../../themes/typography';
import '../../styles/components/AnalyticsCard.css';

function AnalyticsCard({
    title = 'Maximum Invites',
    value = '30',
    valueColor = 'var(--success-secondary-color)',
    icon = <PeopleIcon sx={{ color: 'var(--success-secondary-color)' }} />,
    iconBgColor = 'rgba(38, 193, 232, 0.19)'
}) {
    return (
        <React.Fragment>
            <div className="analytics-card-container">
                <div className="analytics-card-wrapper">
                    <div className="analytics-card-title-container">
                        <Body3 color="#f5f5f5" fontWeight="400">
                            {title}
                        </Body3>
                        <H3 fontWeight="800" style={{ color: valueColor }}>
                            {value}
                        </H3>
                    </div>
                    <div
                        className="analytics-card-icon-container"
                        style={{ backgroundColor: iconBgColor }}
                    >
                        {icon}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AnalyticsCard;
